module.exports = __webpack_public_path__ + "static/media/Pet Package.507b88fb.png";